import PropTypes from "prop-types";
import React from "react";
import classnames from "classnames";

const projectRange = (start, end, min, max) =>
  (end - start) / (max - min) * 100;

const ProgressBar = ({
  min = 0,
  max = 100,
  current = 0,
  className,
  balanceState,
}) => {
  const prefixCls = "progress-bar";
  const componentCls = classnames(prefixCls, className, balanceState);

  const fillCls = `${prefixCls}__fill`;

  const width = projectRange(0, Math.min(max, current), min, max);
  const fillStyle = { width: `${width}%` };

  return (
    <div className={componentCls}>
      <div style={fillStyle} className={fillCls} />
    </div>
  );
};

ProgressBar.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  current: PropTypes.number,
  className: PropTypes.string,
  balanceState: PropTypes.string,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./casper/sass/components/progress-bar/progress-bar.js